import * as React from "react";
import Box from "@sproutsocial/seeds-react-box";
import type { TypeListItemProps } from "./ListItemTypes";

/**
 * Styled-components implementation of ListItem. Used by ListItemHybrid whenever
 * a consumer passes a styled-system prop or a styled() extension. This is the
 * unchanged legacy rendering path (a Box rendered as <li>).
 */
const ListItemStyled = React.forwardRef<HTMLLIElement, TypeListItemProps>(
  ({ isBordered, children, ...rest }, ref) => {
    return (
      <Box
        as="li"
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore legacy ref type mismatch: Box types its ref as a div, but
        // it renders an <li> here and forwards the ref to that element.
        ref={ref}
        borderRadius="outer"
        {...(isBordered
          ? {
              border: 500,
              borderColor: "container.border.base",
              p: 300,
            }
          : {})}
        mt={300}
        // rest carries system props + native <li> attributes. Box is typed to a
        // div, so the li-specific event-handler element types are widened away;
        // the ref (on its own line above) is unaffected by this spread cast.
        {...(rest as Record<string, unknown>)}
      >
        {children}
      </Box>
    );
  }
);

ListItemStyled.displayName = "ListItem";

export default ListItemStyled;
